"use client";

import { SidebarMenuItem } from "@/components/ui/sidebar";
import { Skeleton } from "@/components/ui/skeleton";

interface SidebarSkeletonProps {
  count: number;
}

const SidebarSkeleton = ({ count }: SidebarSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <SidebarMenuItem key={index} className="flex justify-center">
          <div className="flex items-center gap-3 w-full px-2 py-2">
            <Skeleton className="h-[18px] w-[18px] rounded-md flex-shrink-0" />
            <Skeleton className="h-4 flex-1" />
          </div>
        </SidebarMenuItem>
      ))}
    </>
  );
};

export default SidebarSkeleton;
